
































































































































































































































import { Component, Inject, Vue } from 'vue-property-decorator'
import { MemberController } from '@/services/request.service'
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'
import { fileUploader } from '@/services/qiniu.service'

@Component({
  components: {
    VueCropper,
  },
})
export default class Personal extends Vue {
  @Inject() public readonly reloadPage!: any

  public passwordForm: any
  public mode = 'info'
  public editName = false
  public editEnName = false
  public editEmail = false
  public userInfo: any = {}
  public avatarVisible = false
  public avatar = ''
  public passwordVisible = false
  public confirmDirty = false
  public passwordLoading = false
  public editMode = false
  public userEditor = {
    name: '',
    enName: '',
    mobile: '',
    email: '',
  }

  private get rules(): any {
    return {
      name: [{ validator: this.validateZhName, trigger: 'change' }],
      enName: [{ validator: this.validateEnName, trigger: 'change' }],
      email: [
        {
          required: true,
          message: this.$tc('personal.enterEmail'),
          trigger: 'change',
        },
        {
          max: 100,
          message: this.$tc('personal.emailLimit'),
          trigger: 'change',
        },
        {
          type: 'email',
          message: this.$tc('personal.enterCorrectEmail'),
          trigger: 'change',
        },
      ],
    }
  }

  private validateZhName(rule, value, callback) {
    if (!value && !this.userEditor.enName) {
      callback(new Error(this.$tc('staffMgmt.emptyName')))
    } else {
      const userEditor = this.$refs.userEditor as any
      userEditor.clearValidate('enName')
      callback()
    }
  }
  private validateEnName(rule, value, callback) {
    if (!value && !this.userEditor.name) {
      callback(new Error(this.$tc('staffMgmt.emptyName')))
    } else {
      const userEditor = this.$refs.userEditor as any
      userEditor.clearValidate('name')
      callback()
    }
  }

  public selectMode({ selectedKeys }): void {
    this.mode = selectedKeys[0]
  }

  public beforeCreate(): void {
    this.passwordForm = this.$form.createForm(this)
  }

  public created(): void {
    this.getUserInfo()
  }

  public getUserInfo(): void {
    MemberController.queryUserInfo()
      .then(res => {
        this.userInfo = res.data
      })
      .catch(err => {
        console.error(err)
      })
  }

  public changeAvatar(): void {
    this.avatarVisible = true
    this.avatar = this.userInfo.avatarUrl
  }

  public setImage(e): void {
    const file = e.target.files[0]
    if (!file.type.includes('image/')) {
      this.$message.error(this.$tc('personal.wrongAvatar'))
      return
    }
    if (typeof FileReader === 'function') {
      const reader = new FileReader()

      reader.onload = event => {
        const target = event.target as any
        this.avatar = target.result
        const cropper = this.$refs.cropper as any
        cropper.replace(target.result)
      }

      reader.readAsDataURL(file)
    } else {
      this.$message.error(this.$tc('personal.wrongBrowser'))
    }
  }

  public cropAvatar(): void {
    const cropper = this.$refs.cropper as any
    this.avatar = cropper.getCroppedCanvas().toDataURL()
  }

  public activeEditName(): void {
    this.editName = true
    const nameDom = this.$refs.nameInput as any
    nameDom.focus()
  }

  public activeEditEnName(): void {
    this.editEnName = true
    const enNameDom = this.$refs.enNameInput as any
    enNameDom.focus()
  }

  public activeEditEmail(): void {
    this.editEmail = true
    const emailDom = this.$refs.emailInput as any
    emailDom.focus()
  }

  public dataURLtoBlob(dataurl): Blob {
    const arr = dataurl.split(',')
    const mime = arr[0].match(/:(.*?);/)[1]
    const bstr = atob(arr[1])
    let n = bstr.length
    const u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    return new Blob([u8arr], { type: mime })
  }

  public blobToFile(theBlob, fileName) {
    theBlob.lastModifiedDate = new Date()
    theBlob.name = fileName
    return theBlob
  }

  public saveAvatar(): void {
    this.avatarVisible = false
    const name = this.userInfo.name
    const enName = this.userInfo.enName
    const avatar = this.avatar
    const email = this.userInfo.email
    if (avatar.indexOf('http') === -1) {
      const avatarFile = this.blobToFile(
        this.dataURLtoBlob(avatar),
        'avatar_' + new Date().getTime() + '.png'
      )
      const index = avatarFile.name.lastIndexOf('.')
      const suffix = avatarFile.name.slice(index)
      const fileName = 'avatar_' + new Date().getTime() + suffix
      fileUploader(avatarFile, fileName)
        .then(res => {
          const avatarUrl = process.env.VUE_APP_FILE_URL + '/' + res.key
          MemberController.updatePersonalInfo({ avatarUrl, name, enName, email })
            .then(res => {
              this.$message.success(this.$tc('personal.modifySuccess'))
              this.reloadPage()
            })
            .catch(err => {
              console.error(err)
            })
        })
        .catch(err => {
          console.error(err)
        })
    }
  }

  public edit(): void {
    this.editMode = true
    const { name, enName, email, mobile } = this.userInfo
    this.userEditor = {
      name,
      enName,
      email,
      mobile,
    }
  }

  public cancel(): void {
    this.editMode = false
    this.userEditor = {
      name: '',
      enName: '',
      email: '',
      mobile: '',
    }
  }

  public save(): void {
    const userEditor = this.$refs.userEditor as any
    userEditor.validate(valid => {
      if (valid) {
        const { name, enName, email } = this.userEditor
        const request = {
          avatarUrl: this.userInfo.avatarUrl,
          name,
          enName,
          email,
        }
        MemberController.updatePersonalInfo(request)
          .then(res => {
            this.$message.success(this.$tc('common.saveSuccess'))
            this.editMode = false
            this.userInfo = {
              ...this.userInfo,
              ...request,
            }
            this.userEditor = {
              name: '',
              enName: '',
              email: '',
              mobile: '',
            }
          })
          .catch(err => {
            console.error(err)
          })
      } else {
        return false
      }
    })
  }

  public validateToNextPassword(rule, value, callback): void {
    const form = this.passwordForm
    if (/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/.test(value)) {
      if (value && this.confirmDirty) {
        form.validateFields(['confirmPassword'], { force: true })
      }
    } else {
      callback(this.$t('personal.passwordLimit'))
    }
    callback()
  }

  public compareToFirstPassword(rule, value, callback): void {
    const form = this.passwordForm
    if (value && value !== form.getFieldValue('newPassword')) {
      callback(this.$t('personal.wrongPassword'))
    } else {
      callback()
    }
  }

  public handleConfirmBlur(e): void {
    const value = e.target.value
    this.confirmDirty = this.confirmDirty || !!value
  }

  public modifyPassword(): void {
    this.passwordLoading = true
    const form = this.passwordForm
    form.validateFields((err, values) => {
      if (err) {
        this.passwordLoading = false
        return
      }
      const oldPassWord = values.password
      const newPassword = values.newPassword
      MemberController.changePassword({ oldPassWord, newPassword })
        .then(res => {
          this.$message.success(this.$tc('personal.modifySuccess'))
          form.resetFields()
          this.passwordVisible = false
        })
        .catch(err => {
          console.error(err)
        })
        .finally(() => {
          this.passwordLoading = false
        })
    })
  }
}
